var _a, _b;
export var ConsumptionCategory;
(function (ConsumptionCategory) {
    ConsumptionCategory["TRAVEL"] = "\u5DEE\u65C5";
    ConsumptionCategory["HOSPITALITY"] = "\u62DB\u5F85";
    ConsumptionCategory["OPERATION"] = "\u529E\u516C\u8FD0\u8425";
    ConsumptionCategory["EMPLOYEE"] = "\u5458\u5DE5";
})(ConsumptionCategory || (ConsumptionCategory = {}));
export var ConsumptionCategoryObject = (_a = {},
    _a[ConsumptionCategory.TRAVEL] = {
        icon: 'FilledGeneralTravelConfiguration',
        color: 'var(--eui-decorative-neu-500)',
        bgColor: 'var(--eui-decorative-neu-100)'
    },
    _a[ConsumptionCategory.HOSPITALITY] = {
        icon: 'FilledGeneralGoblet',
        color: 'var(--eui-decorative-neu-500)',
        bgColor: 'var(--eui-decorative-neu-100)'
    },
    _a[ConsumptionCategory.OPERATION] = {
        icon: 'FilledGeneralJobs',
        color: 'var(--eui-decorative-neu-500)',
        bgColor: 'var(--eui-decorative-neu-100)'
    },
    _a[ConsumptionCategory.EMPLOYEE] = {
        icon: 'FilledGeneralGroup',
        color: 'var(--eui-decorative-neu-500)',
        bgColor: 'var(--eui-decorative-neu-100)'
    },
    _a);
export var ConsumptionTypeOptions = (_b = {},
    _b[ConsumptionCategory.TRAVEL] = [
        { value: '飞机', label: '飞机', icon: 'FilledGeneralFlight', color: 'var(--eui-function-info-500)', bgColor: 'var(--eui-function-info-100)' },
        { value: '火车/高铁', label: '火车/高铁', icon: 'FilledGeneralTrain', color: 'var(--eui-primary-pri-500)', bgColor: 'var(--eui-primary-pri-100)' },
        { value: '轮船/汽车', label: '轮船/汽车', icon: 'FilledGeneralSailboat', color: 'var(--eui-function-warning-500)', bgColor: 'var(--eui-function-warning-100)' },
        { value: '酒店住宿', label: '酒店住宿', icon: 'FilledGeneralBuilding', color: 'var(--eui-decorative-pur-500)', bgColor: 'var(--eui-decorative-pur-100)' },
        { value: '市内交通', label: '市内交通', icon: 'FilledGeneralCar', color: 'var(--eui-function-warning-500)', bgColor: 'var(--eui-function-warning-100)' },
        { value: '出差补助', label: '出差补助', icon: 'FilledGeneralWallet', color: 'var(--eui-decorative-cyan-500)', bgColor: 'var(--eui-decorative-cyan-100)' },
        { value: '其他差旅', label: '其他差旅', icon: 'FilledGeneralTravelConfiguration', color: 'var(--eui-decorative-neu-500)', bgColor: 'var(--eui-decorative-neu-100)' },
    ],
    _b[ConsumptionCategory.HOSPITALITY] = [
        { value: '招待餐费', label: '招待餐费', icon: 'FilledGeneralKnifeFork', color: 'var(--eui-function-danger-500)', bgColor: 'var(--eui-function-danger-100)' },
        { value: '礼品费', label: '礼品费', icon: 'FilledGeneralInvoice2', color: 'var(--eui-decorative-yel-500)', bgColor: 'var(--eui-decorative-yel-100)' },
        { value: '招待活动', label: '招待活动', icon: 'FilledGeneralGoblet', color: 'var(--eui-function-success-500)', bgColor: 'var(--eui-function-success-100)' },
        { value: '招待交通', label: '招待交通', icon: 'FilledGeneralDriver', color: 'var(--eui-primary-pri-500)', bgColor: 'var(--eui-primary-pri-100)' },
    ],
    _b[ConsumptionCategory.OPERATION] = [
        { value: '办公用品', label: '办公用品', icon: 'FilledGeneralPrinter', color: 'var(--eui-function-info-500)', bgColor: 'var(--eui-function-info-100)' },
        { value: '通讯/邮寄', label: '通讯/邮寄', icon: 'FilledGeneralMessageSend', color: 'var(--eui-primary-pri-400)', bgColor: 'var(--eui-primary-pri-100)' },
        { value: '软件/云服务', label: '软件/云服务', icon: 'FilledGeneralTool', color: 'var(--eui-decorative-pur-500)', bgColor: 'var(--eui-decorative-pur-100)' },
        { value: '其他运营', label: '其他运营', icon: 'FilledGeneralJobs', color: 'var(--eui-decorative-neu-500)', bgColor: 'var(--eui-decorative-neu-100)' },
    ],
    _b[ConsumptionCategory.EMPLOYEE] = [
        { value: '工作餐补', label: '工作餐补', icon: 'FilledGeneralKnifeFork', color: 'var(--eui-function-warning-500)', bgColor: 'var(--eui-function-warning-100)' },
        { value: '团队建设', label: '团队建设', icon: 'FilledGeneralGroup', color: 'var(--eui-function-success-500)', bgColor: 'var(--eui-function-success-100)' },
        { value: '培训/会议', label: '培训/会议', icon: 'FilledGeneralChampion', color: 'var(--eui-primary-pri-500)', bgColor: 'var(--eui-primary-pri-100)' },
        { value: '节日福利', label: '节日福利', icon: 'FilledGeneralActivity', color: 'var(--eui-decorative-mag-500)', bgColor: 'var(--eui-decorative-mag-100)' },
        { value: '交通补助', label: '交通补助', icon: 'FilledGeneralGiftBag', color: 'var(--eui-decorative-cyan-500)', bgColor: 'var(--eui-decorative-cyan-100)' },
    ],
    _b);
